import { Helmet } from 'react-helmet';
import HomeFeatureSpotlights from './components/FeatureSpotlight/HomeFeatureSpotlights';
import AnnouncementBanner from './components/Announcement/AnnouncementBanner';
import HomeHero from './components/HomeHero/HomeHero';
import HomeClose from './components/HomeClose/HomeClose';

import GNBankCardGrid from "./components/GNBankCardGrid"

import HomeInfo from './components/HomeInfo/HomeInfo';

import './App.css';
import SimpleHero from './components/SimpleHero/SimpleHero';

function App() {
  return (
    <>
      <Helmet>
        <title>GN Bank – Personal & Business Banking</title>
        <meta
          name="description"
          content="High-yield savings, checking, CDs, and online banking services from GN Bank."
        />
        <meta
          name="keywords"
          content="GN Bank Chicago, Groupe Nduom Bank, Checking Account, Savings, Loans, Online Banking"
        />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://gnbank.net/" />
        <meta property="og:title" content="GN Bank – Personal & Business Banking" />
        <meta
          property="og:description"
          content="High-yield savings • Checking • Loans • Online & Mobile banking"
        />
        <meta property="og:image" content="https://gnbank.net/og.png" />
        <meta property="og:image:secure_url" content="https://gnbank.net/og.png" />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="GN Bank – Personal & Business Banking" />
        <meta property="og:site_name" content="GN Bank" />
        <meta property="og:locale" content="en_US" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="GN Bank – Personal & Business Banking" />
        <meta
          name="twitter:description"
          content="High-yield savings • Checking • Loans • Online & Mobile banking"
        />
        <meta name="twitter:image" content="https://gnbank.net/og.png" />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <HomeHero />
      {/* <SimpleHero/> */}
      <AnnouncementBanner />

      <HomeInfo/>
      <HomeFeatureSpotlights />
      {/* <HomeClose /> */}
      <GNBankCardGrid/>

      
    </>
  );
}

export default App;
